module.exports = __webpack_public_path__ + "static/img/contest_popup_top_brd.38fd8575.png";